import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import PdfCoRequest from "../../api/PdfCoRequest";
import * as PdfDetectedFieldsNormalize from "./normalize";
import { requestConvertToPdf, setPdfUrl } from "../pdf-viewer/actions";
import { prop } from "ramda";
import { checkIfJobIsCompleted } from "../project/actions";

//Helper
const getContentTypeOfFile = (file) => {
  const type = prop("type", file);

  if (type === "application/pdf") {
    return "application/pdf";
  }

  return "application/octet-stream";
};

export const clearAllDetectedFields = createAction(
  "project/CLEAR_ALL_DETECTED_FIELDS",
  () => {
    return {
      payload: {},
    };
  }
);

export const setIsShown = createAction(
  "pdfDetectedField/SET_IS_SHOWN",
  (value) => {
    return {
      payload: { value },
    };
  }
);

export const getPDFFieldsInfo = createAsyncThunk(
  "pdfDetectedField/GET_PDF_FIELD_INFO",
  async ({ file, url, base64 }, thunkAPI) => {
    thunkAPI.dispatch(requestConvertToPdf());
    try {
      let sendURL;
      if (file) {
        const preSignedUrlResponse = await PdfCoRequest.getPreSignedUrl(
          {
            name: file.name,
            encrypt: true,
          },
          {
            headers: {
              "Content-Type": getContentTypeOfFile(file),
            },
          }
        );

        await PdfCoRequest.putFileFromUrl(
          preSignedUrlResponse.presignedUrl,
          file,
          {
            customConfig: {
              noToken: true,
            },
            headers: {
              "Content-Type": getContentTypeOfFile(file),
            },
          }
        );

        sendURL = preSignedUrlResponse.url;
        thunkAPI.dispatch(setPdfUrl(preSignedUrlResponse.url));
      }

      if (base64) {
        const preSignedUrlResponse = await PdfCoRequest.getPreSignedUrlFromBase64(
          {
            encrypt: true,
            file: base64
          }
        );

        sendURL = preSignedUrlResponse.url;
        thunkAPI.dispatch(setPdfUrl(preSignedUrlResponse.url));
      }

      if (url) {
        sendURL = url;
      }

      const data = await PdfCoRequest.getPDFFieldsInfo({
        async: true,
        url: sendURL,
      });

      const fieldData = await thunkAPI
        .dispatch(
          checkIfJobIsCompleted({
            jobId: data.jobId,
          })
        )
        .unwrap();

      return PdfDetectedFieldsNormalize.listDetectedField.success(fieldData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
